// SingleEvent.js
import React, { useState } from "react";
import '../../App.css';
import ArticleCard from "../ArticleCard";
import MUICard2 from "../MUICard2";
import { Box } from "@mui/material";
import MUISingleEventCard from "../MUISingleEventCard";

function SingleEvent12() {

    const [heroSectionEventData] = useState({
        image: "images/Barrie-Concerts/2024-2025/bc_05_17_25.jpg",
        title: 'PianoFest',
        subtitle: 'Henry From, Theadora Koski, Luke Welch (This concert is free.)',
        date: 'Saturday 17 May 2025 7.30pm',
        location: 'Hiway Church, 50 Anne Street North, Barrie',

    });

    const [eventData] = useState({
        program: `Please click on the tab below for an outline of the program when available.  More program details will become available closer to the performance.`,
        performers: `Henry From, Theadora Koski, Luke Welch`,
        performers2: `Named as one of Canadian Broadcasting Corporation’s Top 30 Classical Musicians under 30, Henry From is a pianist and composer currently based in Toronto.      Henry is currently pursuing a Bachelor of Music in piano performance at the Glenn Gould School (GGS) of the Royal Conservatory of Music, in Toronto. Theadora Koski began formal piano studies at the age of six under the direction of Cheryl Graham.  She progressed to RCM Level 10 in just four years, receiving multiple awards.   In January 2024, after top marks at the SSP Steinway International Piano Competition, Theadora performed live at Carnegie Hall for the closing Gala.  She was the winner of the 2024 Senior Rosebowl at Barrie Kiwanis Music Festival.  Theadora is currently working towards her ARCT Performer’s Diploma and plans for a career in performance and teaching. Award-winning Canadian pianist Luke Welch was born in Toronto, Ontario, Canada and grew up nearby in Mississauga. He played his first public performance at age seven, and his early private piano teachers include Kyzysztof Jedrysik, Catherine Kuzeljevich, and John-Paul Bracey. He later graduated from Western University in Canada with Bachelor and Master of Music degrees and completed additional graduate studies in Rotterdam, the Netherlands.   He has performed extensively on the international stage including appearances in Canada, the USA, and Europe.  He has collaborated with a number of orchestras and dance companies.  His recordsing have achieved intertational critical acclaim.    He was appointed to the Faculty of Piano at the RCM Oscar Peterson Program in 2022. `,
        performerLink: 'https://henryfrompianist.com/ ',
        ticketInfo: `This concert is free.`,

    });

    const barrieConcert = [
        {
            title: 'Duo Turgeon',
            description: 'From Bruce with Love',
            imageUrl: 'images/Barrie-Concerts/2024-2025/bc_05-10-24.jpg',
            link: '/SingleEvent6'
        },
        {
            title: 'Dévah Quartet',
            description: 'Dévah Quartet',
            imageUrl: 'images/Barrie-Concerts/2024-2025/bc_30-11-24.jpg',
            link: '/SingleEvent7'
        },
        {
            title: 'True North Brass',
            description: 'Dancing Across the Globe',
            imageUrl: 'images/Barrie-Concerts/2024-2025/bc_18_01_25.jpg',
            link: '/SingleEvent8'
        },
    ];
    

    return (
        <Box> 
            <MUISingleEventCard
                image={heroSectionEventData.image}
                title={heroSectionEventData.title}
                subtitle={heroSectionEventData.subtitle}
                date={heroSectionEventData.date}
                location={heroSectionEventData.location}  

            />
            <ArticleCard 
                title={eventData.title}
                subtitle={eventData.subtitle}
                date={eventData.date}
                location={eventData.location}
                program={eventData.program}
                performers={eventData.performers}
                performers2={eventData.performers2}
                performerLink={eventData.performerLink}
                ticketInfo={eventData.ticketInfo}
            />
            <Box marginY='30px'>
                <MUICard2 title="2024/25 Barrie Concerts" events={barrieConcert} buttonLink="/BarrieConcert" />
            </Box>
        </Box>
    );
}

export default SingleEvent12;
